export default __webpack_public_path__ + "static/media/roadmapMb3.2f251553.svg";